import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";

export default function RatingPopup({ show = true, onSubmit, onClose, ratingNumber = 0 }) {
  const [rating, setRating] = useState(ratingNumber);

  const handleSubmit = () => {
    if (rating === 0) return;
    onSubmit?.(rating);
    setRating(0);
    onClose?.();
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.3 }}
          className="bg-white w-full max-w-md mx-auto p-6 rounded-2xl shadow-2xl border border-gray-100"
        >
          <h3 className="text-lg font-semibold text-center text-gray-800 mb-4">
            Rate Your Support Experience
          </h3>

          <div className="flex justify-center mb-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <motion.div
                key={num}
                whileHover={{ scale: 1.3 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setRating(num)}
                className={`mx-2 cursor-pointer transition-colors duration-200 ${
                  rating >= num ? "text-yellow-400" : "text-gray-300"
                }`}
              >
                <Star
                  size={28}
                  fill={rating >= num ? "#facc15" : "none"}
                  strokeWidth={1.5}
                />
              </motion.div>
            ))}
          </div>

          <div className="flex justify-center gap-4 mt-4">
            <button
              onClick={onClose}
              className="text-sm px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
            >
              Skip
            </button>
            <button
              onClick={handleSubmit}
              className="text-sm px-4 py-2 rounded-lg bg-[#0381CA] text-white hover:bg-[#0367a6] transition"
            >
              Submit
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
